import "./bootstrap";
import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import "notyf/notyf.min.css"; // Import Notyf CSS

createInertiaApp({
    resolve: (name) => {
        const pages = import.meta.glob("./Pages/**/*.vue", { eager: true });
        return pages[`./Pages/${name}.vue`];
    },
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) }).use(plugin);

        // Enable Vue DevTools in development
        app.config.devtools = true;
        app.config.performance = true;

        app.mount(el);

        return app;
    },
});
